/*
全局添加的自定义 js 
*/

// 实现与 {{ xxx | handle }} 一样的功能
function handleize(str) {
  // 确保转换为字符串
  let result = str.toString()
    .toLowerCase()        // 转换为小写字母
    .replace(/\s+/g, '-') // 替换空格为连字符
    .replace(/[^\w\-]+/g, '') // 移除非字母数字字符
    .replace(/--+/g, '-')   // 将多个连字符合并为一个
    .replace(/^-+/, '')     // 移除开头的连字符
    .replace(/-+$/, '');    // 移除结尾的连字符

  // 如果结果是以数字开头，则在前面加上下划线
  if (/^\d/.test(result)) {
    result = '_' + result;
  }

  return result;
}

// 滚动到指定元素位置
const scrollToTarget = (target) => {
  let mql = window.matchMedia('(max-width: 767px)');
  let isMobile = mql.matches;
  let fixedHeaderHeight = 0;
  let distance = window.scrollY + target.getBoundingClientRect().top;
  const fixHeaderNavigation = document.querySelector('#StickyHeaderWrap #SiteHeader.site-header--stuck');
  const ul = document.querySelector('#pProductOverviewMenu ul');
  const catalog = ul ? getComputedStyle(ul).height : '0px';
  if (fixHeaderNavigation) {
    const fixHeaderNavigationHeight = getComputedStyle(fixHeaderNavigation).height;
    fixedHeaderHeight = Number(fixHeaderNavigationHeight.replace('px', '')) + Number(catalog.replace('px', ''));
  } else {
    const headerNavigation = document.querySelector('#SiteHeader');
    const trustBar = document.querySelector('#SiteHeader .trust-bar');
    let headerNavigationHeight = getComputedStyle(headerNavigation).height
    if (trustBar) {
      headerNavigationHeight = Number(headerNavigationHeight.replace('px', '')) + (isMobile ? 38 : 40);
    }
    fixedHeaderHeight = headerNavigationHeight + Number(catalog.replace('px', ''));
    distance -= isMobile ? 40 : 69;
  }

  savedFixedHeaderHeight = fixedHeaderHeight;

  const headerCountDown = document.querySelector('.shopify-section-group-header-group.countdown-section');
  if (headerCountDown && headerCountDown.style.display === 'block' && !headerCountDown.classList.contains('hide')) {
    let headerCountDownHeight = fixHeaderNavigation ? 0 : headerCountDown.clientHeight;
    if (isMobile) {
      headerCountDownHeight = 0;
    }
    window.scrollTo(0, distance - fixedHeaderHeight + 1 - headerCountDownHeight);
  } else {
    window.scrollTo(0, distance - fixedHeaderHeight + 1);
  }
}

// PC 端浏览器切换到其他 Tab 页时，如果购物车不为空，修改当前 Tab 的标题
// 获取当前页面的原始标题
const originalTitle = document.title;
let currentTitle = originalTitle;
let tabInterval;
// 监听页面可见性变化事件
document.addEventListener('visibilitychange', function() {
  if (tabInterval) {
    clearInterval(tabInterval);
  }
  if (document.hidden) {
    theme.cart.getCart().then((val) => {
      const itemCount = val.item_count;
      if (itemCount) {
        tabInterval = setInterval(() => {
          currentTitle = currentTitle === originalTitle ? `👉 ${itemCount} items waiting for you` : originalTitle;
          document.title = currentTitle;
        }, 1000)
      }
    })
  } else {
    // 页面切换到前台时，恢复原始标题
    document.title = originalTitle;
  }
});

/* 优化后的 resize 监听事件 */
;(function() {
    var throttle = function(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function() {
            if (running) { return; }
            if (timeout) clearTimeout(timeout);
            running = true;
            var timeout = setTimeout(() => {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            },500)
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("resize", "optimizedResize");
})();

function syncCartDrawer(val) {
  if (val.sections && val.sections['mini-cart']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(val.sections['mini-cart'], 'text/html');
    
      const cartDrawer = document.querySelector('#CartDrawer');
      cartDrawer.innerHTML = doc.querySelector("#CartDrawer").innerHTML;
  }
}

function addProduct(item) {
  const productId = item.dataset.productId;
  const formId = item.dataset.formId;
  const recommendationForm = document.querySelector('.recommendation-form');
  const idInput = document.querySelector('.recommendation-form input[name="id"]');
  const addToCartBtn = document.querySelector('.recommendation-form .add-to-cart');
  recommendationForm.id = formId;
  idInput.value = productId;
  addToCartBtn.click();
  item.classList.add('btn--loading');
}

let observer = new MutationObserver(callback);
observer.observe(document.body, { attributes: true, attributeFilter: ['style'], attributeOldValue: true });

function callback(mutationsList, observer) {
  for (let mutation of mutationsList) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
      let oldValue = mutation.oldValue;
      let newValue = document.body.style.position;
      if (oldValue !== newValue) {
        const ShopifyChat = document.querySelector('#ShopifyChat');
        if (newValue === 'fixed') {
          ShopifyChat.classList.add('chat-position');
        } else {
          ShopifyChat.classList.remove('chat-position');
        }
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const endTimeStamp = new Date().getTime() + 300000;
  const updateShopifyNewsletterModal = setInterval(() => {
    const currentTimeStamp = new Date().getTime();
    if (currentTimeStamp >= endTimeStamp) {
      clearInterval(updateShopifyNewsletterModal);
      return;
    }
    const shopifyNewsletterModal = document.querySelector('form-embed');
    console.log('shopifyNewsletterModal: ', shopifyNewsletterModal)
    if (shopifyNewsletterModal) {
        // 访问 shadow root
        const shadowRoot = shopifyNewsletterModal.shadowRoot;

        const style = document.createElement('style');
        style.innerHTML = `#app-embed div[data-testid="app-router"] > button {
          margin-top: 0 !important;
        }
        #app-embed div[data-testid="app-router"] #form-container-ref div[data-testid="btn-close-wrapper"] {
          top: 20px;
        }
        `;

      shadowRoot.appendChild(style);
      clearInterval(updateShopifyNewsletterModal);
    }
  }, 500);
})